import type { IconDefinition } from '../index.tsx';

export const iconX: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconX',
  icon: [
    16,
    16,
    [],
    '',
    'M5.17148 8.00015L0.585693 3.41436L3.41412 0.585938L7.99991 5.17172L12.5857 0.585938L15.4141 3.41436L10.8283 8.00015L15.4141 12.5859L12.5857 15.4144L7.99991 10.8286L3.41412 15.4144L0.585693 12.5859L5.17148 8.00015Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
